import { utcMoment } from '../moment-utils';

let singletonTimezone: { name: string; offset: number }[];

export function getTimezonesWithOffsets(): { name: string; offset: number }[] {
  if (singletonTimezone) {
    return singletonTimezone;
  }
  const timezones = (Intl as any).supportedValuesOf('timeZone');
  const getOffsetInMinutes = (timezone) => {
    const utc = utcMoment(undefined, true).toDate();
    const tzDate = new Date(utcMoment().toDate().toLocaleString('en-US', { timeZone: timezone }));
    const offset = Math.round((tzDate.getTime() - utc.getTime()) / 60000); // Convert milliseconds to minutes
    return offset;
  };

  singletonTimezone = timezones.map((timezone) => ({
    name: timezone,
    offset: getOffsetInMinutes(timezone),
  }));
  return singletonTimezone;
}

export const TIMEZONE_ABBREVIATIONS: { name: string; offset: number }[] = [
  { name: 'HST', offset: -600 }, // Pacific/Honolulu
  { name: '-0930', offset: -570 }, // Pacific/Marquesas
  { name: 'AKDT', offset: -540 }, // America/Anchorage
  { name: 'PDT', offset: -480 }, // America/Los_Angeles
  { name: 'MDT', offset: -420 }, // America/Denver
  { name: 'CDT', offset: -360 }, // America/Chicago
  { name: 'EDT', offset: -300 }, // America/New_York
  { name: 'AST', offset: -240 }, // America/Halifax
  { name: 'NDT', offset: -210 }, // America/St_Johns
  { name: 'GMT', offset: 0 }, // Etc/UTC
  { name: 'CET', offset: 60 }, // Europe/Paris
  { name: 'EET', offset: 120 }, // Europe/Athens
  { name: 'MSK', offset: 180 }, // Europe/Moscow
  { name: 'IRST', offset: 210 }, // Asia/Tehran
  { name: 'GST', offset: 240 }, // Asia/Dubai
  { name: '+0430', offset: 270 }, // Asia/Kabul
  { name: 'IST', offset: 330 }, // Asia/Kolkata
  { name: '+0545', offset: 345 }, // Asia/Kathmandu
  { name: '+0630', offset: 390 }, // Asia/Yangon
  { name: 'CST', offset: 480 }, // Asia/Shanghai
  { name: '+0845', offset: 525 }, // Australia/Eucla
  { name: 'JST', offset: 540 }, // Asia/Tokyo
  { name: 'ACST', offset: 570 }, // Australia/Adelaide
  { name: 'AEST', offset: 600 }, // Australia/Sydney
  { name: '+1030', offset: 630 }, // Australia/Lord_Howe
  { name: 'NZST', offset: 720 }, // Pacific/Auckland
  { name: '+1245', offset: 765 }, // Pacific/Chatham
];
